export default __webpack_public_path__ + "static/product-b-press-high-temp-95aad8097bc246934c4862b949ed77f9.jpg";